// extracted by mini-css-extract-plugin
export default {"container":"filePage_container__mrv6Q","section":"filePage_section__BY0lf","title":"filePage_title__0udXT"};